<!--
 * @Author: JDY
 * @Date: 2020-10-15 09:58:34
 * @LastEditTime: 2021-04-30 17:38:34
 * @LastEditors: JDY
 * @Description: In User Export
-->
<template>
  <a-button type="primary" @click="exportClick" :loading="exportLoading">
    <a-icon type="cloud-download" />导出
  </a-button>
</template>

<script>
import { requestGet } from '@/api/api'

export default {
  name: 'Export',
  props: {
    // 表单校验用字段
    // eslint-disable-next-line
    columns: {
      type: Array,
      default: () => {}
    },
    url: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    },
    xlsxName: {
      type: String,
      default: '导出'
    }
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    /**
     * 导出
     */
    exportClick () {
      const that = this
      that.exportLoading = true
      const { params } = that.$props
      const newParams = {
        export: true
      }
      if (params) {
        newParams.sort = params.sort
        newParams.where = params.where
      }
      requestGet(that.$props.url, newParams)
        .then((res) => {
          const { data } = res.result
          const { columns } = that.$props
          const newColumns = columns.filter((item) => {
            item.key = item.dataIndex
            return item.dataIndex !== 'operation'
          })
          this.$emit('click', newColumns, data)
          // that.outputXlsxFile(newColumns, data, '**' + that.$props.xlsxName + that.moment(new Date()).format('YYYYMMDDHHmmss'))
        })
        .catch((err) => {
          that.$notification.error({
              message: err.message
          })
        })
        .finally(() => {
          that.exportLoading = false
        })
    }
  }
}
</script>
